import { render, staticRenderFns } from "./ParticipantDamageClaim.vue?vue&type=template&id=5b7027da&"
import script from "./ParticipantDamageClaim.vue?vue&type=script&lang=js&"
export * from "./ParticipantDamageClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports